/** Sélection d'une trace ou d'une route — EF-GPX-002. */

import type { JSX } from 'preact';
import { selectTrackElement, trackSelection } from '../state';
import { formatCount } from '../format';

export function TrackSelectionDialog(): JSX.Element | null {
  const selection = trackSelection.value;
  if (selection === null) return null;

  return (
    <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label="Choisir une trace">
      <div class="modal">
        <h2 style="margin-top:0;">Plusieurs éléments dans ce fichier</h2>
        <p>Rien n’est importé avant votre choix.</p>
        <div class="actions actions--stacked">
          {selection.elements.map((element) => (
            <button
              key={`${element.type}-${element.index}`}
              type="button"
              onClick={() => {
                void selectTrackElement(element.index);
              }}
            >
              {element.label} — {formatCount(element.pointCount)} points
            </button>
          ))}
        </div>
        <div class="actions">
          <button
            type="button"
            onClick={() => {
              trackSelection.value = null;
            }}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
